module.exports = {"pathContext":{"name":"LocationFilters","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"ids","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"Int","ofType":null}}},{"defaultValue":null,"description":null,"name":"inventoryDepository","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-location-filters.json
// module id = 1462
// module chunks = 277351654996655